_ = require('lodash')
moment = require('moment')
$ = require('jquery')

GroupEventListCtrl = ($scope ,$translate ,$filter , $location ,groupEventService ,$ngConfirm ,flash) ->
  listDetail = this
  listDetail.pageSize = 4
  listDetail.lstEvents = []
  listDetail.currentPage = 0
  listDetail.isLoading = false
  listDetail.noResults = true
  listDetail.totalPages = 0
  listDetail.showCreateButton = false
  listDetail.groupAdmin = false
  listDetail.loadMore = ->
    listDetail.isLoading = true
    listDetail.currentPage++
    params =
      id : $scope.groupDetail.id
      page : listDetail.currentPage
      page_size : listDetail.pageSize
    groupEventService.listEvent(params)
    .then (data) ->
      listDetail.lstEvents = _.union(listDetail.lstEvents, data.events)
      listDetail.totalPages = data.total_pages
      listDetail.noResults = listDetail.lstEvents.length == 0
    .finally ->
      listDetail.isLoading = false

  listDetail.hasMore = ->
    listDetail.noResults == false && listDetail.currentPage < listDetail.totalPages

  refreshListData = ->
    listDetail.lstEvents = []
    listDetail.currentPage = 0
    listDetail.isLoading = false
    listDetail.noResults = true
    listDetail.totalPages = 0
    listDetail.loadMore()

  groupEventService.checkJoinGroup($scope.groupDetail.id).then (data) ->
    listDetail.showCreateButton = data.joined
    if data.role == "admin"
      listDetail.groupAdmin = true
  listDetail.displayPeriod = (startTime, endTime) ->
    reText = ""
    if !startTime && !endTime
      return reText
    reText = $filter('translate')('_GROUP_EVENT.PERIOD_NAME')
    reText += ": "
    reText += listDetail.displayDateByLang(startTime)
    reText += "~"
    reText += listDetail.displayDateByLang(endTime)
    reText

  listDetail.displayDateByLang = (time) ->
    if !time
      return ""
    d = moment(time)
    formatText = 'YYYY-MM-DD(ddd)'
    if /^ja/i.test $translate.preferredLanguage()
      formatText = 'LL(ddd)'
      moment.locale('ja')
    d.format(formatText)

  listDetail.displayParticipants = (number) ->
    reText = $filter('translate')('_GROUP_EVENT.PARTICIPANTS')
    reText += ': '
    reText += number
    if /^ja/i.test $translate.preferredLanguage()
      reText += '人'
    reText

  listDetail.displayNoParticipants = (number) ->
    reText = $filter('translate')('_GROUP_EVENT.NONPARTICIPANTS')
    reText += ': '
    reText += number
    if /^ja/i.test $translate.preferredLanguage()
      reText += '人'
    reText

  listDetail.goToCreatePage = ->
    url = '/group-event/registration?id=' + $scope.groupDetail.id
    $location.url(url)

  listDetail.gotoEditEventDetail = (id , event) ->
    if event.stopPropagation
      event.stopPropagation()
    url = "/group-event/#{id}/edit"
    $location.path(url)

  listDetail.gotoEventDetail = (id) ->
    if !listDetail.showCreateButton
      return
    url = '/group-event/' + id
    $location.path(url)

  listDetail.deleteEvent = (id , event) ->
    if event.stopPropagation
      event.stopPropagation()
    mess = $filter('translate')('_GROUP_EVENT.CONFIRM_MESS')
    deleteFunc = ->
      groupEventService.deleteEvent(id)
        .then (resp) ->
          refreshListData()
        .catch (resp) ->
          flash.error $filter('translate')('API_ERROR')
    config =
      title: ''
      content: mess
      buttons:
        Cancel:
          text: $filter('translate')('_GROUP_EVENT.CANCEL')
        OkButton:
          text: 'OK'
          action: deleteFunc

    $ngConfirm(config)


  $scope.$watch('listEventCtrl.lstEvents' , () ->
    if listDetail.currentPage <= 1
      return
    $("html, body").animate({ scrollTop:$(document).height()}, "slow")
  , false)

  listDetail.loadMore()
  listDetail

GroupEventListCtrl.$inject = [
  '$scope'
  '$translate'
  '$filter'
  '$location'
  'groupEventService'
  '$ngConfirm'
  'flash'
]

module.exports = GroupEventListCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/group-event/group-event-list-controller.coffee